export default __webpack_public_path__ + "static/media/venha-ser-glampartner.d05038a7.png";